import { Platform } from 'react-native';
import * as WebBrowser from 'expo-web-browser';
import { apiService } from './api';

/** Opens a paid payment's invoice PDF: a new tab on web, the in-app
 * browser on phones (view, save or share from there). */
export async function openInvoice(paymentId: string): Promise<void> {
  // Web: open the tab inside the tap itself — browsers block tabs opened
  // after an await as popups — then point it at the signed link.
  const tab = Platform.OS === 'web' ? window.open('', '_blank') : null;
  try {
    const res = await apiService.getInvoiceLink(paymentId);
    if (res.statusCode !== 1000 || !res.data?.url) throw new Error(res.errors?.[0]?.message || 'Could not open the invoice');
    if (Platform.OS === 'web') {
      if (tab) tab.location.href = res.data.url;
      else window.location.href = res.data.url;
      return;
    }
    await WebBrowser.openBrowserAsync(res.data.url);
  } catch (error) {
    tab?.close();
    throw error;
  }
}
